import { createSlice } from "@reduxjs/toolkit";

const drmFlipFlagSlice = createSlice({
  name: "drmFlipFlag",
  initialState: {
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setFlipFlag: (state) => {
      state.isLoading = true;
    },
    setFlipFlagSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setFlipFlagFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetFlipFlagState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setFlipFlag,
  setFlipFlagSuccess,
  setFlipFlagFailure,
  resetFlipFlagState,
} = drmFlipFlagSlice.actions;

export default drmFlipFlagSlice.reducer;
